query GetUserEmailSignature {
    loggedInUser {
        id
        emailSignature
    }
}
